var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvChargerOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 1.5C4.21875 1.5 1.5 4.36419 1.5 7.97244C1.5 10.0582 2.41359 11.9051 3.82128 13.0856C4.03287 13.263 4.06056 13.5784 3.88312 13.79C3.70568 14.0016 3.39031 14.0293 3.17872 13.8518C1.54287 12.48 0.5 10.3518 0.5 7.97244C0.5 3.87915 3.60154 0.5 7.5 0.5C7.77614 0.5 8 0.723858 8 1C8 1.27614 7.77614 1.5 7.5 1.5Z",
    fill: "url(#paint0_linear_9519_19586)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.5C11.2812 1.5 14 4.36419 14 7.97244C14 10.0582 13.0864 11.9051 11.6787 13.0856C11.4671 13.263 11.4394 13.5784 11.6169 13.79C11.7943 14.0016 12.1097 14.0293 12.3213 13.8518C13.9571 12.48 15 10.3518 15 7.97244C15 3.87915 11.8985 0.5 8 0.5C7.72386 0.5 7.5 0.723858 7.5 1C7.5 1.27614 7.72386 1.5 8 1.5Z",
    fill: "url(#paint1_linear_9519_19586)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9519_19586",
    x1: 4.25,
    y1: 1,
    x2: 4.25,
    y2: 13.4687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BFD54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9519_19586",
    x1: 11.25,
    y1: 1,
    x2: 11.25,
    y2: 13.4687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BFD54"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvChargerOn);
export default __webpack_public_path__ + "static/media/ev-charger-on.729e332aa5cee2d60bc67991895f3400.svg";
export { ForwardRef as ReactComponent };